import { useAuthStore } from "@/stores/auth";
import { computed } from "vue";
import { useRouter } from "vue-router";
import { RouteNames } from "@/router";
import { useNotifications } from "@/common/notification";
import { useI18n } from "vue-i18n";

export const useStopImpersonation = (): {
  stopImpersonationAndRedirect: () => void;
} => {
  const authStore = useAuthStore();
  const currentUser = computed(() => authStore.currentUser);
  const router = useRouter();
  const { t } = useI18n();

  const stopImpersonationAndRedirect = (): void => {
    // this needs to be non-reactive because the current user changes when stopping the impersonation
    const impersonatedUserId = currentUser.value?.id;

    authStore.stopImpersonate().then(async (success) => {
      if (success) {
        if (impersonatedUserId !== undefined) {
          // Note that all components where the user may be redirected to after ending the impersonation
          // must properly handle the change in the currentUser state because they may not get refreshed
          // when the route does not actually change.
          await router.push({
            name: RouteNames.USER_PROFILE,
            params: { id: impersonatedUserId },
          });
        } else {
          await router.push({
            name: RouteNames.DASHBOARD,
          });
        }
        useNotifications().push(
          "info",
          t("userManagement.settings.impersonateStopSuccess"),
        );
      } else {
        useNotifications().push(
          "error",
          t("userManagement.settings.impersonateStopError"),
          t("userManagement.settings.impersonateStopErrorTitle"),
        );
      }
    });
  };

  return { stopImpersonationAndRedirect };
};
